import { AxiosInstance } from "axios";
import { type ICore } from "./interfaces";

export function getUsersAddressesBuilder(apiClient: AxiosInstance) {
  return async function getUsersAddresses(): Promise<ICore.UserAddress[]> {
    const response = await apiClient.get(`/accounts/user-addresses/`);
    return response.data.results;
  };
}
